import React from "react";

import { cx } from "../../utils/dom";
import { Text } from "../text";
import { Color } from "../../utils/theme";

type InputLabelProps = Omit<React.HTMLAttributes<HTMLLabelElement>, "size">;

const InputLabel = React.forwardRef<HTMLLabelElement, InputLabelProps>(
  ({ children, className, color, ...props }, ref) => {
    return (
      <Text
        ref={ref}
        size="sm"
        color={(color as Color) || "gray"}
        variant="light"
        as="label"
        className={cx([className, "p-input-label"])}
        {...props}
      >
        {children}
      </Text>
    );
  }
);

InputLabel.displayName = "InputLabel";

export default InputLabel;
